<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-exclamation-triangle title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{ 'model.triggers' | transloco }}</p>
        <p>{{ 'menu.descriptions.triggers' | transloco }}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column lg:flex-row">
              <button
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                [label]="'common.new' | transloco"
                class="lg:mr-2 p-button-primary mb-2 lg:mb-0"
                icon="pi pi-plus"
                pButton
                pRipple
                routerLink="new"
              ></button>
              <button
                (click)="confirmAndDeleteSelected()"
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                [disabled]="selected.length == 0"
                [label]="'common.delete' | transloco"
                class="p-button-danger mb-2 lg:mb-0 lg:mr-2"
                icon="pi pi-trash"
                pButton
                pRipple
              ></button>
              <p-toggleButton
                (click)="selected.length > 0 ? changeActiveStates() : null"
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                [(ngModel)]="activeButtonState"
                [disabled]="selected.length == 0"
                [offLabel]="'misc.setInactive' | transloco" [onLabel]="'misc.setActive' | transloco"
                class="mb-2 sm:mb-0"
                offIcon="pi pi-times"
                onIcon="pi pi-check"
                styleClass="w-full"
              ></p-toggleButton>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                [label]="'common.importCsv' | transloco"
                class="p-button-secondary md:mr-2"
                icon="pi pi-upload"
                pButton
                routerLink="import"
              ></button>
              <button
                (click)="filtersVisible = !filtersVisible"
                [label]="'common.filters' | transloco"
                class="p-button-secondary"
                icon="pi pi-sliders-h"
                pButton
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                [label]="'common.importCsv' | transloco"
                class="p-button-secondary md:mr-2"
                icon="pi pi-upload"
                pButton
                routerLink="import"
              ></button>
              <button
                (click)="filtersVisible = !filtersVisible"
                [label]="'common.filters' | transloco"
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
                pButton
              ></button>
            </div>
          </div>
        </div>
        <p-table
          (onLazyLoad)="onPageChange($event)"
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selected"
          [lazy]="true"
          [paginator]="true"
          [responsive]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [totalRecords]="totalTriggers"
          [value]="triggers"
          breakpoint="1575px"
          dataKey="dataKey"
          sortField="name"
          styleClass="p-datatable-striped"
        >
          <ng-template pTemplate="header">
            <tr>
              <th *ngIf="'ROLE_OPERATOR' | userHasRole" class="selection-column-width" scope="col"></th>
              <th class="selection-column-width" scope="col"></th>
              <th pSortableColumn="name" scope="col">
                {{ 'attribute.name' | transloco }}
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="ownerUuid" scope="col">
                {{ 'attribute.ruleType' | transloco }}
                <p-sortIcon field="ownerUuid"></p-sortIcon>
              </th>
              <th pSortableColumn="category" scope="col">
                {{ 'attribute.category' | transloco }}
                <p-sortIcon field="category"></p-sortIcon>
              </th>
              <th pSortableColumn="entityType" scope="col">
                {{ 'attribute.entityType' | transloco }}
                <p-sortIcon field="entityType"></p-sortIcon>
              </th>
              <th pSortableColumn="active" scope="col">
                {{ 'attribute.active' | transloco }}
                <p-sortIcon field="active"></p-sortIcon>
              </th>
              <th scope="col">
                {{ 'model.asset' | transloco }} / {{ 'model.device' | transloco }}
              </th>
              <th pSortableColumn="lastEvaluation" scope="col">
                {{ 'attribute.result' | transloco }}
                <p-sortIcon field="lastEvaluation"></p-sortIcon>
              </th>
              <th pSortableColumn="evaluationDate" scope="col">
                {{ 'attribute.evaluationDate' | transloco }}
                <p-sortIcon field="evaluationDate"></p-sortIcon>
              </th>
              <th *ngIf="'ROLE_OPERATOR' | userHasRole" class="w-10rem" scope="col">
                {{ 'common.actions' | transloco }}
              </th>
            </tr>
          </ng-template>
          <ng-template let-expanded="expanded" let-trigger pTemplate="body">
            <tr *ngIf="!loadingTriggers" class="fadein">
              <td>
                <span class="p-column-title bold">{{ 'common.expand' | transloco }}</span>
                <button [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" [pRowToggler]="trigger" class="p-button-text p-button-rounded p-button-plain" pButton
                        pRipple
                        type="button"></button>
              </td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole">
                <span class="p-column-title bold">{{ 'common.select' | transloco }}</span>
                <p-tableCheckbox (click)="evaluateActiveButtonState()" [value]="trigger"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.name' | transloco }}</span>
                <a
                  *ngIf="trigger.entityType === 'DEVICE'"
                  [routerLink]="'/devices/'+trigger.device.uuid+'/details'"
                  [state]="{showView: 'events', trigger: trigger}"
                >{{ trigger.name }}</a>
                <a
                  *ngIf="trigger.entityType === 'ASSET'"
                  [routerLink]="'/assets/'+trigger.asset.uuid+'/details'"
                  [state]="{showView: 'events', trigger: trigger}"
                >{{ trigger.name }}</a>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.ruleType' | transloco }}</span>
                <p *ngIf="trigger.ownerUuid">{{ "common.user" | transloco }}</p>
                <p *ngIf="!trigger.ownerUuid">{{ "menu.system" | transloco }}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.category' | transloco }}</span>
                <p>{{ 'model.triggerCategories.' + trigger.category.toLowerCase() | transloco }}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.entityType' | transloco }}</span>
                <p *ngIf="trigger.entityType === 'DEVICE'">{{ 'model.device' | transloco }}</p>
                <p *ngIf="trigger.entityType === 'ASSET'">{{ 'model.asset' | transloco }}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.active' | transloco }}</span>
                <p *ngIf="trigger.active">{{ 'common.active' | transloco }}</p>
                <p *ngIf="!trigger.active">{{ 'common.inactive' | transloco }}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'model.asset' | transloco }}</span>
                <p *ngIf="trigger.entityType === 'DEVICE'">{{ trigger.device ? trigger.device.serialNumber : '' }}</p>
                <p *ngIf="trigger.entityType === 'ASSET'">{{ trigger.asset ? trigger.asset.alias : '' }}</p>
              </td>
              <td *ngIf="trigger.lastEvaluation !== null && trigger.lastEvaluation !== undefined" class="m-0">
                <span class="p-column-title bold">{{ 'attribute.result' | transloco }}</span>
                <p [className]="trigger.lastEvaluation ? 'success-color' : 'danger-color'">
                  <i [className]="trigger.lastEvaluation ? 'pi pi-check' : 'pi pi-times'"></i>
                  {{ (trigger.lastEvaluation ? 'common.true' : 'common.false') | transloco }}
                </p>
              </td>
              <td *ngIf="trigger.lastEvaluation === null || trigger.lastEvaluation === undefined" class="m-0">
                <span class="p-column-title bold">{{ 'attribute.result' | transloco }}</span>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.evaluationDate' | transloco }}</span>
                {{ trigger.evaluationDate | customDate }}
              </td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole">
                <span class="p-column-title bold">{{ 'common.actions' | transloco }}</span>
                <div class="flex justify-content-end">
                  <button
                    [routerLink]="trigger.entityType === 'DEVICE' ?
                         'DEVICE' + '/' + trigger.device.uuid + '/' + trigger.deviceMeasurement.uuid + '/' + trigger.name + '/edit' :
                         'ASSET' + '/' + trigger.asset.uuid + '/' + trigger.assetMeasurement.uuid + '/' + trigger.name + '/edit'"
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                    pButton
                    pRipple
                  ></button>
                  <button
                    (click)="confirmAndDelete(trigger)"
                    *ngIf="'ROLE_OPERATOR' | userHasRole"
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                    pButton
                    pRipple
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingTriggers" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole" class="row-height-md">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template let-trigger pTemplate="rowexpansion">
            <tr>
              <td colspan="100">
                <div class="p-p-3 w-full">
                  <p-table [value]="[trigger]" styleClass="w-full">
                    <ng-template pTemplate="header">
                      <tr>
                        <th scope="col">
                          {{ 'attribute.measurementName' | transloco }}
                        </th>
                        <th scope="col">
                          {{ 'attribute.valueEvaluated' | transloco }}
                        </th>
                        <th scope="col">
                          {{ 'attribute.condition' | transloco }}
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template let-triggerSingle pTemplate="body">
                      <tr>
                        <td>
                          <span class="p-column-title bold">{{ 'attribute.measurementName' | transloco }}</span>
                          <p
                            *ngIf="triggerSingle.entityType === 'DEVICE'">{{ triggerSingle.deviceMeasurement ? triggerSingle.deviceMeasurement.name : '' }}</p>
                          <p
                            *ngIf="triggerSingle.entityType === 'ASSET'">{{ triggerSingle.assetMeasurement ? triggerSingle.assetMeasurement.name : '' }}</p>
                        </td>
                        <td>
                          <span class="p-column-title bold">{{ 'attribute.valueEvaluated' | transloco }}</span>
                          {{ trigger.lastValueEvaluated }}
                        </td>
                        <td>
                          <span class="p-column-title bold">{{ 'attribute.condition' | transloco }}</span>
                          <p-tag severity="info" value="{{triggerSingle.type}}({{triggerSingle.expression}})"></p-tag>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex">
              <div class="my-auto">
                <div *ngIf="totalTriggers == 0">
                  {{ 'pagination.empty' | transloco }}
                </div>
                <div *ngIf="totalTriggers > 0">
                  {{ 'pagination.showing' | transloco }} {{ first + 1 }}
                  {{ 'pagination.to' | transloco }} {{ (first + rows) >= totalTriggers ? totalTriggers : (first + rows) }}
                  {{ 'pagination.of' | transloco }} {{ totalTriggers }}
                  {{ (totalTriggers > 1 ? 'pagination.entries' : 'pagination.entry') | transloco }}
                </div>
              </div>
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{ 'common.filters' | transloco }}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{ 'attribute.name' | transloco }}</label>
      </div>
      <div class="col-12">
        <input
          (keyup.enter)="filtersVisible = false; applyFilters()"
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          appAutoFocus
          class="w-full"
          id="name"
          pInputText
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{ 'attribute.active' | transloco }}</label>
      </div>
      <div class="col-12">
        <div class="p-field-radiobutton margin-top">
          <p-radioButton
            [(ngModel)]="currentFilters.active"
            [label]="'misc.allTypes' | transloco"
            name="active"
            value="null"
          ></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton
            [(ngModel)]="currentFilters.active"
            [label]="'misc.activeOnly' | transloco"
            name="active"
            value="true"
          ></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton
            [(ngModel)]="currentFilters.active"
            [label]="'misc.inactiveOnly' | transloco"
            name="active"
            value="false"
          ></p-radioButton>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{ 'attribute.ruleType' | transloco }}</label>
      </div>
      <div class="col-12 flex flex-column">
        <div>
          <button
            (click)="setSelectedRuleType(null)"
            [ngClass]="currentFilters.isUserTrigger == null ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-circle-off"></i>
            {{ 'common.all' | transloco }}
          </button>
        </div>
        <div>
          <button
            (click)="setSelectedRuleType(true)"
            [ngClass]="currentFilters.isUserTrigger === true ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-user"></i>
            {{ 'common.user' | transloco }}
          </button>
        </div>
        <div>
          <button
            (click)="setSelectedRuleType(false)"
            [ngClass]="currentFilters.isUserTrigger === false ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-cog"></i>
            {{ 'common.system' | transloco }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{ 'attribute.entityType' | transloco }}</label>
      </div>
      <div class="col-12 flex flex-column">
        <div>
          <button
            (click)="setSelectedEntityType(null)"
            [ngClass]="currentFilters.entityType == null ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-circle-off"></i>
            {{ 'common.all' | transloco }}
          </button>
        </div>
        <div>
          <button
            (click)="setSelectedEntityType('DEVICE')"
            [ngClass]="currentFilters.entityType === 'DEVICE' ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-mobile"></i>
            {{ 'model.devices' | transloco }}
          </button>
        </div>
        <div>
          <button
            (click)="setSelectedEntityType('ASSET')"
            [ngClass]="currentFilters.entityType === 'ASSET' ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-map-marker"></i>
            {{ 'model.assets' | transloco }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label *ngIf="currentFilters.entityType == null" style="color: #b2b2b2;">
          {{ 'attribute.identifier' | transloco }}
        </label>
        <label *ngIf="currentFilters.entityType === 'DEVICE'">
          {{ 'attribute.serialNumber' | transloco }}
        </label>
        <label *ngIf="currentFilters.entityType === 'ASSET'">
          {{ 'attribute.alias' | transloco }}
        </label>
      </div>
      <div class="col-12">
        <input
          *ngIf="currentFilters.entityType == null"
          class="w-full"
          disabled
          pInputText
          type="text"
        >
        <input
          (keyup.enter)="filtersVisible = false; applyFilters()"
          *ngIf="currentFilters.entityType === 'DEVICE'"
          [(ngModel)]="currentFilters.serialNumber"
          class="w-full"
          pInputText
          type="text"
        >
        <input
          (keyup.enter)="filtersVisible = false; applyFilters()"
          *ngIf="currentFilters.entityType === 'ASSET'"
          [(ngModel)]="currentFilters.alias"
          class="w-full"
          pInputText
          type="text"
        >
      </div>
    </div>
    <div class="col-12 p-mt-3">
      <p-button
        (onClick)="filtersVisible = false; applyFilters()"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.serialNumber ||
          currentFilters.alias ||
          currentFilters.entityType ||
          (currentFilters.active != null) ||
          (currentFilters.isUserTrigger != null)
        )"
        [label]="'common.filter' | transloco"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        (click)="resetFilters(); filtersVisible = false;"
        [label]="'common.clear' | transloco"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
